export function weightedRandom<T>(weights: number[], values: T[]): null | T {
  const totalWeight = weights.reduce((acc, w) => acc + w, 0);
  const random = Math.random() * totalWeight;

  let weightSum = 0;
  for (let i = 0; i < weights.length; i++) {
    weightSum += weights[i];
    if (random < weightSum) {
      return values[i];
    }
  }

  return null;
}

export function deductShieldAndHealth(shield: number, health: number, damage: number): { shield: number, health: number } {
  if (shield >= damage) {
    return { shield: shield - damage, health };
  }

  return {
    shield: 0,
    health: Math.max(health - (damage - shield), 0),
  };
}

export function clamp(value: number, min: number, max: number): number {
  const num = Math.min(Math.max(value, min), max);
  return Number.isFinite(num) ? num : min;
}